export enum WorldpayTransactionType {
  Genio = 'G',
  Orbit = 'O',
  ProductReplacement = 'R',
  RepairAndCareCancellation = 'D',
  Scheme = 'S',
  Web = 'W',
}
